import { useEffect, useState } from 'react';

import { IntegratedService } from '@classpass/protobuf-definitions/lib/web/models/partners/service_and_resource';

import URLS from 'constants/urls';
import { httpClient } from 'helpers/http';
import { reportError } from 'helpers/error-logging';

const fetchIntegratedService = async (venueId, classId) => {
  const response = await httpClient.get(URLS.manageServices.services.integratedServiceById(venueId, classId));
  return response.data ? IntegratedService.fromJSON(response.data) : null;
};

// Fetches the full integrated service (name, description, duration, existing
// pricing) for the detail/edit page. Read-only fields the class list doesn't
// carry come from here. Returns `service: null` while loading or on error.
export default function useIntegratedService(venueId, classId) {
  const [service, setService] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (!venueId || !classId) {
      setIsLoading(false);
      return undefined;
    }

    let isMounted = true;
    setIsLoading(true);

    const loadService = async () => {
      try {
        const result = await fetchIntegratedService(venueId, classId);
        if (isMounted) setService(result);
      } catch (error) {
        reportError('Failed to fetch integrated service', { error, venueId, classId });
        if (isMounted) setService(null);
      } finally {
        if (isMounted) setIsLoading(false);
      }
    };

    loadService();

    return () => {
      isMounted = false;
    };
  }, [venueId, classId]);

  return { service, isLoading };
}
